module.exports = __webpack_public_path__ + "img/ssid-badge.41a3ee88.svg";